import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MobileNativeAudio} from "../cspa.api";
import {IosBridgeBase} from "../../../../mobile/api-services/bridge/ios-bridge-base";

@Injectable({
  providedIn: 'root'
})
export class IosNewNativeApi
  implements MobileNativeAudio {

  constructor(private bridgeBase: IosBridgeBase) {
  }

  // #### audio implementation #####
  /*
  this is the same implementation of audio actions as it was in old cspa
   */

  /**
   * clear recording buffer
   */
  clear(): Observable<void> {
    this.bridgeBase.log("calling clear");
    return this.bridgeBase.callForResponse<void>('clear',{});
  }

  /**
   * start recording
   */
  record() {
    this.bridgeBase.log("calling record");
    return this.bridgeBase.callForResponse<void>('record',{}).subscribe();
  }

  /**
   * stop recording or playback
   */
  stop(): Observable<void> {
    this.bridgeBase.log("calling stop");
    return this.bridgeBase.callForResponse<void>('stop',{});
  }

  /**
   * start recording playback
   */
  play2() {
    this.bridgeBase.log("calling play");
    return this.bridgeBase.callForResponse<void>('play',{}).subscribe();
  }

  /**
   * clean up and release recording device
   */
  terminate() {
    this.bridgeBase.log("calling terminate");
    return this.bridgeBase.callForResponse<void>('terminate',{}).subscribe();
  }

  /**
   * initialize recording device, returns true if positive
   * @param callback
   */
  initAudio(callback: (state: boolean) => void) {
    this.bridgeBase.log(" calling init");
    return this.bridgeBase.callForResponse<boolean>('initAudio',{}).subscribe(
      it => callback(it)
    )
  }
}
